import { format, addDays } from "date-fns";
import * as types from "./types";

function formatDate(date) {
  return `${format(date, "yyyy-MM-dd")}T00:01:00`;
}
const today = new Date();
const date = formatDate(addDays(today, -6));

const dashboardState = {
  invoicesByStatus: null,
  invoicesByPaymentMode: null,
  invoicesByDate: null,
  dateRange: { from: date, to: formatDate(today) },
  typeFilters: [],
  totalInvoices: 0,
  totalPayments: 0,
  errors: []
};

export default (state = dashboardState, action) => {
  switch (action.type) {
    case types.CLEAR_STORE: {
      return {
        ...state,
        ...dashboardState
      };
    }
    case types.CHANGE_DATE_RANGE: {
      let { from, to } = action.payload;

      from = from ? formatDate(from) : null;
      to = to ? formatDate(to) : null;

      return {
        ...state,
        dateRange: { from, to }
      };
    }
    case types.FETCHING_DASHBOARD_DATA_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case types.FETCHING_DASHBOARD_DATA_ERROR: {
      return {
        ...state,
        errors: action.payload
      };
    }
    case types.FETCHING_INVOICE_TYPES_SUCCESS: {
      const { types: invoiceTypes } = action.payload;
      let typeFilters = [];

      if (invoiceTypes?.length > 0) {
        typeFilters = invoiceTypes?.map(f => ({
          label: f,
          key: f,
          value: f,
          isActive: false
        }));

        typeFilters.unshift({
          label: "ALL",
          key: "ALL",
          isActive: true
        });
      }
      return {
        ...state,
        typeFilters
      };
    }
    case types.SET_TYPE: {
      const clickedType = action.payload;

      const isAllSelected = (clickedType.key !== "ALL" && clickedType.isActive) || clickedType.key === "ALL";

      const newTypes = state.typeFilters.map(type => {
        const newType = {
          ...type,
          isActive: type.key === clickedType.key ? !type.isActive : false
        };
        if (newType.key === "ALL") newType.isActive = isAllSelected;
        return newType;
      });

      return {
        ...state,
        typeFilters: newTypes
      };
    }
    default:
      return state;
  }
};
